import { render, staticRenderFns } from "./consultForm.vue?vue&type=template&id=2b3917c0&scoped=true&"
import script from "./consultForm.vue?vue&type=script&lang=js&"
export * from "./consultForm.vue?vue&type=script&lang=js&"
import style0 from "./consultForm.vue?vue&type=style&index=0&id=2b3917c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3917c0",
  null
  
)

export default component.exports